
























import { Component, Prop, Vue } from 'vue-property-decorator'
import AuthDisplay from './AuthDisplay.vue'
import { SafioVersion } from '@/util/version'

@Component({
  components: {
    AuthDisplay,
  }
})
export default class PageHeader extends Vue {
  safioVersion = SafioVersion

  @Prop({ type: String, default: '' })
  public rightBarClass: string

  get environmentClass(): string {
    const host = window.location.hostname.toLowerCase()
    const isStaging = host === 'staging.safio.app'
    const isProd = host === 'safio.app'

    if (isStaging) return 'non-prod'
    if (isProd) return 'prod'

    return 'non-prod'
  }
}
